export default __webpack_public_path__ + "static/media/electoral.4d8acece.png";